import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { rethrowCloseCauseIfNeeded2q8fs9csuucwc as rethrowCloseCauseIfNeeded } from './ByteReadChannelOperations.mjs';
import { get_size2imoy2jq11jxl as get_size } from './core/BytePacketBuilder.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_autoFlush() {
  return false;
}
var ByteWriteChannelClass;
function ByteWriteChannel() {
  if (ByteWriteChannelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ByteWriteChannel', VOID, VOID, VOID, [0]);
    ByteWriteChannelClass = $;
  }
  return ByteWriteChannelClass;
}
function *flushIfNeeded(_this__u8e3s4, $completion) {
  rethrowCloseCauseIfNeeded(_this__u8e3s4);
  if (_this__u8e3s4.get_autoFlush_zfdl3o_k$() || get_size(_this__u8e3s4.get_writeBuffer_t7kuc6_k$()) >= 1048576)
    yield* _this__u8e3s4.flush_4wsz1p_k$($completion);
  return Unit_instance;
}
function ByteWriteChannel$flushAndClose$ref(p0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return yield* p0.flushAndClose_3zd2q_k$($completion);
  }), 0, 1, 205, 'flushAndClose', [p0]);
}
//region block: exports
export {
  ByteWriteChannel$flushAndClose$ref as ByteWriteChannel$flushAndClose$ref1ad3q8nm0coau,
  flushIfNeeded as flushIfNeededij7q93lpr53w,
  ByteWriteChannel as ByteWriteChannel3jkhlhzuuoxp1,
};
//endregion

//# sourceMappingURL=ByteWriteChannel.mjs.map
